import { FC, useContext } from "react";

import { PeopleAlt } from "@mui/icons-material";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Theme,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { NavLink } from "react-router-dom";

import { AuthStateContext } from "@/contexts/AuthContext";
import { useSidebar } from "@/contexts/SidebarContext";

import { collapsedAppIconSx } from "./collapsedAppIconSx";
import { frameNavItemSx } from "./frameNavItemSx";

interface Props {
  dense?: boolean;
  logout?: () => void;
  onMenuClick?: () => void;
  collapsed?: boolean;
}

const UsersAdminMenu: FC<Props> = ({ dense = false, collapsed = false }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery((theme as Theme).breakpoints.down("sm"));
  const { setCollapsed } = useSidebar();
  const { currentUser } = useContext(AuthStateContext);
  const { rubi_org_id: orgId } = currentUser || {};

  const hideSideBar = () => {
    setCollapsed(true);
  };

  const userMenuItems = [
    {
      to: `/organizations/${orgId}/users`,
      text: "Users",
      icon: <PeopleAlt />,
    },
  ];

  const menuItemSx = {
    pl: collapsed ? 1 : 2,
    py: dense ? 1 : 1.5,
    minHeight: collapsed ? 48 : "auto",
    justifyContent: collapsed ? "center" : "flex-start",
  };

  const renderItems = (items: typeof userMenuItems) =>
    items.map((item) => (
      <Tooltip
        key={item.to}
        title={collapsed ? item.text : ""}
        placement="right"
        arrow
      >
        <MenuItem
          component={NavLink}
          to={item.to}
          onClick={isSmall ? hideSideBar : undefined}
          sx={[frameNavItemSx(), menuItemSx]}
        >
          <ListItemIcon
            sx={{
              minWidth: collapsed ? 0 : 40,
              mr: collapsed ? 0 : 2,
              justifyContent: "center",
            }}
          >
            {item.icon}
          </ListItemIcon>
          {!collapsed && <ListItemText primary={item.text} />}
        </MenuItem>
      </Tooltip>
    ));

  return (
    <div className="menu">
      {!collapsed ? (
        <div className="sidebar-top">
          <div className="app-name">
            <span>MANAGEMENT CONSOLE</span>
          </div>
        </div>
      ) : (
        <div className="application-item">
          <Tooltip title="Users Management" placement="right" arrow>
            <IconButton
              aria-label="Management Console"
              size="large"
              disableRipple
              sx={collapsedAppIconSx}
            >
              <PeopleAlt />
            </IconButton>
          </Tooltip>
        </div>
      )}
      <div className="left-menu">{renderItems(userMenuItems)}</div>
    </div>
  );
};

export default UsersAdminMenu;
